import {Pipe, PipeTransform} from '@angular/core';
import {currencyList} from '@app/pipe/moneda.pipe';

@Pipe({
    name: 'montoDinero',
    standalone: true
})
export class MontoDineroPipe implements PipeTransform {

    transform(value: any, codigoMoneda?: any , cantD?: any ): any {

        if (!value) {
            value = 0;
        }

        if (!cantD) {
            cantD = 2;
        } else if (!cantD && cantD > 4) {
            cantD = 4;
        }

        const moneda = currencyList.find(c => c.codigoMoneda === codigoMoneda);
        const simbolo = moneda ? moneda.simbolo : 'Desc.';

        return `${simbolo} ${parseFloat(value).toFixed(cantD)}`;
    }

}
